import { render, staticRenderFns } from "./RetainUsers.vue?vue&type=template&id=25b8e61d&scoped=true&"
import script from "./RetainUsers.vue?vue&type=script&lang=js&"
export * from "./RetainUsers.vue?vue&type=script&lang=js&"
import style0 from "./RetainUsers.vue?vue&type=style&index=0&id=25b8e61d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8e61d",
  null
  
)

export default component.exports